<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="col-12 md:col-4 lg:col-4 nopad">
        <p-fieldset class="p-field nopad" legend="{{'Cf_Infos' | translate}}">
          <span class="p-float-label size_cent">
            <input formControlName="login" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Cf_Login' | translate}} *</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <input formControlName="lastname" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Cf_LastName' | translate}}</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <input formControlName="firstname" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Cf_FirstName' | translate}}</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <input formControlName="email" class="p-inputtext size_cent" pInputText type="text" />
            <label>{{'Cf_Uemail' | translate}}</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <div>{{'Cf_Desc' | translate}}</div>
            <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
          </span>
          <span class="p-float-label size_cent">
            <div class="grid">
              <div class="col-2">
                <p-inputSwitch formControlName="dateexpirationbool"></p-inputSwitch>
              </div>
              <div class="col-10">
                <p-calendar monthNavigator="true" yearNavigator="true" showButtonBar="true" yearRange="2000:2050"
                  formControlName="dateexpiration" dateFormat="dd/mm/yy"
                  id="dateexpiration"
                  [firstDayOfWeek]="firstDayOfWeek"
                  appendTo="body">
                </p-calendar>
                <label for="dateexpiration">{{'Cf_DateExp' | translate}}</label>
              </div>
            </div>
          </span>
          <span class="p-float-label size_cent">
            <div class="grid">
              <div class="col-10">{{'Cf_Active' | translate}}</div>
              <div class="col-2">
                <p-inputSwitch formControlName="active"></p-inputSwitch>
              </div>
            </div>
          </span>
        </p-fieldset>
        <p-fieldset class="p-field nopad" legend="{{'Cf_Abs' | translate}}">
          <div class="grid">
            <div class="col-10">{{'Cf_Autorizdel' | translate}}</div>
            <div class="col-2">
              <p-inputSwitch formControlName="usedelegate"></p-inputSwitch>
            </div>
            <p-dropdown class="col-12 align" formControlName="delegateuserlogin" [options]="userListDelegate" optionLabel="label" optionValue="value">
            </p-dropdown>
            <div class="col-12 grid p-float-label size_cent">
              <div class="col-6">
                <p-calendar monthNavigator="true" yearNavigator="true" showButtonBar="true" yearRange="2000:2050"
                  formControlName="datebegindelegate" dateFormat="dd/mm/yy"
                  id="datebegindelegate"
                  [firstDayOfWeek]="firstDayOfWeek"
                  appendTo="body">
                </p-calendar>
                <label for="datebegindelegate">{{'Cf_DateFrom' | translate}}</label>
              </div>
              <div class="col-6">
                <p-calendar monthNavigator="true" yearNavigator="true" showButtonBar="true" yearRange="2000:2050"
                  formControlName="dateenddelegate" dateFormat="dd/mm/yy"
                  id="dateenddelegate"
                  [firstDayOfWeek]="firstDayOfWeek"
                  appendTo="body">
                </p-calendar>
                <label for="dateenddelegate">{{'Cf_DateTo' | translate}}</label>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
      <div class="col-12 md:col-4 lg:col-4 nopad">
        <p-fieldset class="p-field nopad" legend="{{'Cf_Auth' | translate}}">
          <span class="p-float-label size_cent">
            <p-password
              formControlName="password"
              id="password"
              [feedback]="false"
              >
            </p-password>
            <label for="password">{{'Cf_Pass' | translate}}</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <p-password
              formControlName="passwordcf"
              id="passwordcf"
              [feedback]="false"
              >
            </p-password>
            <label for="passwordcf">{{'Cf_PassCf' | translate}}</label>
          </span>
          <span class="p-float-label size_cent form-margin">
            <div class="grid">
              <div class="col-2">
                <p-inputSwitch formControlName="useautoconnection"></p-inputSwitch>
              </div>
              <div class="col-10 p-float-label size_cent">
                <input formControlName="autoconnectionuser" class="p-inputtext size_cent" pInputText type="text" />
                <label>{{'Cf_AutoCnxUser' | translate}}</label>
              </div>
            </div>
          </span>
        </p-fieldset>
        <p-fieldset class="p-field  nopad" legend="{{'Cf_Auto' | translate}}">
          <div class="grid">
            <div class="col-10">{{'Cf_Autorizcf' | translate}}</div>
            <div class="col-2">
              <p-inputSwitch formControlName="allowconfiguser"></p-inputSwitch>
            </div>
            <div class="col-10">{{'Cf_Autorizdlg' | translate}}</div>
            <div class="col-2">
              <p-inputSwitch formControlName="allowconfigdelegate"></p-inputSwitch>
            </div>
            <div class="col-12 p-field-radiobutton">
              <p-radioButton (onClick)="onUserType(1)" formControlName="usertype" name="usertype" value=1 inputId="opt1">
              </p-radioButton>
              <label for="opt1" class="ml-2">{{'Cf_UserGed' | translate}}</label>
            </div>
            <div class="col-12 p-field-radiobutton">
              <p-radioButton (onClick)="onUserType(0)" formControlName="usertype" name="usertype" value=0 inputId="opt2">
              </p-radioButton>
              <label for="opt2" class="ml-2">{{'Cf_UserAllg' | translate}}</label>
              <div class="col-12 grid">
                <div class="col-1"></div>
                <div class="col-11 grid">
                  <div class="col-10">{{'Cf_AllowNum' | translate}}</div>
                  <div class="col-2">
                    <p-inputSwitch formControlName="allowscantouchscreen"></p-inputSwitch>
                  </div>
                  <div class="col-10">{{'Cf_AllowMod' | translate}}</div>
                  <div class="col-2">
                    <p-inputSwitch formControlName="allowmodeler"></p-inputSwitch>
                  </div>
                  <div class="col-10">{{'Cf_AllowGed' | translate}}</div>
                  <div class="col-2">
                    <p-inputSwitch formControlName="allowsearch"></p-inputSwitch>
                  </div>
                  <div class="col-10">{{'Cf_AllowBsk' | translate}}</div>
                  <div class="col-2">
                    <p-inputSwitch formControlName="allowbasket"></p-inputSwitch>
                  </div>
                  <div class="col-10">{{'Cf_AllowModd' | translate}}</div>
                  <div class="col-2">
                    <p-inputSwitch formControlName="allowaddmodeldoc"></p-inputSwitch>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
      <p-fieldset class="p-field col-12 md:col-4 lg:col-4 nopad" legend="{{'Cf_Groups' | translate}}">
        <p-listbox
          formControlName="groupList"
          [options]="groupListBase"
          multiple="multiple"
          checkbox="checkbox"
          scrollHeight="51vh"
          >
        </p-listbox>
      </p-fieldset>
    </div>
  </form>
</div>

<div class="col-12 lg:col-12 md:col-12 align-right">
  @if (dataItem) {    
    @if (dataItem.duplicate === false) {
      <button
        (click)="deleteItem()"
        class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
        >
        {{'Delete' | translate}}
      </button>
    }
  }
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
